import React from 'react';

import { Dropdown, IDropdown, toOptions } from './Dropdown';

interface IDropdownMultiSelect extends IDropdown {
  multiSelectLabel?: React.ReactNode;
  labelSeparate?: React.ReactNode;
}

export const DropdownMultiSelect: React.FC<IDropdownMultiSelect> = (props) => {
  const {
    children,
    multiSelectLabel = 'Multiple',
    labelSeparate = ',',
    displayEmpty,
    customRenderValue,
    renderValue,
    ...others
  } = props;

  return (
    <Dropdown
      multiple
      renderValue={(value: string[]) => {
        const selection = toOptions(children).filter((child) => value.includes(child.props.value))
          .map((child: React.ReactElement) => ([child.props.children, labelSeparate])).flat();
        // removes last labelSeparate;
        selection.pop();

        const shouldRenderValue = renderValue && (customRenderValue || (displayEmpty && (!value || !value.length)));

        const optionLabel: React.ReactNode = shouldRenderValue
          ? renderValue(value)
          : selection;

        return multiSelectLabel && value.length > 1 ? multiSelectLabel : optionLabel;
      }}
      {...others}
    >
      {children}
    </Dropdown>
  );
};
